import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BillingManagementService } from '../../../service/billing-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { FocusInputType, InteractionType, KeyValues15, LocalService, Payment, PrepaidDetailReason, Status, TriggeredEvent } from '../../../service/local.service';

@Component({
  selector: 'app-pay-from-wallet',
  templateUrl: './pay-from-wallet.component.html',
  styleUrls: ['./pay-from-wallet.component.scss']
})
export class PayFromWalletComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["pay_from_wallet"]; details: KeyValues15; isCustomerSelected: boolean; isShowOtpVerification = false;
  @Input() receiptId = ''; maxBodyHeight = 0; customerId = ''; customerIdBusiness = ''; paidDate = ''; isOtpverified = false; upi = '';
  amount: number = null; businessOrUserId = ''; isShowPayment = false; isElligibleToAddUpiDetail = false; ids: string[] = [];
  prepaidDetailReason: PrepaidDetailReason = PrepaidDetailReason.DedcutedForReceipt; interactionTypePayment: InteractionType;
  elementIds: any = {
    business_customer_pay: 'business_customer_pay',
    customer_pay: 'customer_pay',
    business_upi: 'business_upi'
  };

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, public billingManagementService: BillingManagementService, private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad(isSelectCustomerType = false) {
    this.isOtpverified = false;
    this.billingManagementService.getPaymentFromWalletDetails(this.prepaidDetailReason == PrepaidDetailReason.DedcutedForReceipt ? this.receiptId : this.businessOrUserId, this.prepaidDetailReason, this.amount).subscribe(result => {
      this.details = result;
      if (this.details.v13 && this.details.v13 != '')
        this.isElligibleToAddUpiDetail = this.localService.isBusinessAvailable(result.v13);
      this.paidDate = this.details.v2;
      if (this.paidDate == '') {
        this.customerId = this.details.v3;
        this.customerIdBusiness = this.details.v7;
        this.setDefault();
      }
      if (isSelectCustomerType) {
        this.onCustomerSelected(this.isCustomerSelected ? '2' : '1')
      }
    });
  }

  onVerifiedOtpVerified(event) {
    this.isOtpverified = true;
    this.onPopupSave();
  }

  onPopupSave() {
    if (this.details.v12 == "0") {
      this.billingManagementService.updateUpiByReceiptId(this.receiptId, this.upi).subscribe(result => {
        if (result.status == Status.Success) {
          this.onLoad();
        } else {
          this.localService.showInformationByStatus(result.status, true);
        }
      });
    } else {
      let isOwnCustomer = this.isCustomerSelected ? this.customerId == this.localService.selected.user : this.localService.isBusinessAvailable(this.customerIdBusiness);
      if (!isOwnCustomer && !this.isShowOtpVerification) {
        this.isShowOtpVerification = true;
      }
      else if (isOwnCustomer || this.isOtpverified) {
        this.isShowOtpVerification = false;
        this.billingManagementService.deductFromPrepaid(this.isCustomerSelected ? this.customerId : this.customerIdBusiness, this.isCustomerSelected ? InteractionType.User : InteractionType.Business, this.amount, this.prepaidDetailReason, this.prepaidDetailReason == PrepaidDetailReason.DedcutedForReceipt ? this.receiptId : this.businessOrUserId, this.ids).subscribe(result => {
          if (result.status == Status.Success) {
            this.activeModal.close({ event: TriggeredEvent.Ok });
          } else {
            this.onLoad();
            this.localService.showInformationByStatus(result.status);
          }
        });
      }
    }
  }

  onCustomerSelected(value) {
    this.businessOrUserId = '';
    this.isOtpverified = false;
    this.isShowOtpVerification = false;
    this.isCustomerSelected = value != '1';
    if (this.isCustomerSelected && this.details.v6 == '0') {
      this.businessOrUserId = this.customerId;
    } else if (!this.isCustomerSelected && this.details.v10 == '0') {
      this.businessOrUserId = this.customerIdBusiness;
    }
  }

  setDefault() {
    setTimeout(() => {
      if (this.details.v12 == "0") {
        this.localService.onFocusNextInput(this.elementIds.business_upi, FocusInputType.TextBox);
      } else if (this.customerIdBusiness != '' || this.customerId != '') {
        this.amount = parseFloat(this.details.v1);
        if (this.isCustomerSelected == undefined || this.isCustomerSelected == null) {
          if (this.customerIdBusiness != '' && this.details.v10 == '1') {
            this.localService.onFocusNextInput(this.elementIds.business_customer_pay, FocusInputType.RadioButton);
          } else if (this.customerId != '' && this.details.v6 == '1') {
            this.localService.onFocusNextInput(this.elementIds.customer_pay, FocusInputType.RadioButton);
          } else if (this.customerIdBusiness != '') {
            this.localService.onFocusNextInput(this.elementIds.business_customer_pay, FocusInputType.RadioButton);
          } else {
            this.localService.onFocusNextInput(this.elementIds.customer_pay, FocusInputType.RadioButton);
          }
        }
      }
    }, 100);
  }

  onShowPayment() {
    this.interactionTypePayment = this.isCustomerSelected ? InteractionType.User : InteractionType.Business;
    this.isShowPayment = true;
  }

  onPaymentProccesed(e: any) {
    if (this.prepaidDetailReason == PrepaidDetailReason.DedcutedForReceipt)
      this.businessOrUserId = '';
    this.onLoad(true);
  }
}
